import { getRailsClient } from "../client";

import { Banner } from "./types";

export const fetchUserBanner = async (): Promise<Banner | null> => {
  const client = getRailsClient();
  try {
    const response = await client.get("/api/internal_api/v1/custom_notifications");
    return response.data;
  } catch (error) {
    console.error("Error fetching user banner:", error);
    return null;
  }
};

export const clearUserBanner = async (bannerId: number): Promise<void> => {
  const client = getRailsClient();
  const API_PATH = `/api/internal_api/v1/custom_notifications/${bannerId}`;
  try {
    await client.put(API_PATH);
  } catch (error) {
    console.error("Error clearing user banner:", error);
    throw error;
  }
};
